import { all, call, put, takeLeading } from 'redux-saga/effects';

import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';
import {
  contractLinkCreateLoadPdfFailure,
  contractLinkCreateLoadPdfRequest,
  contractLinkCreateLoadPdfSuccess,
} from '@app/features/contractLink/contractLinkCreate/actions';
import { modalOpen } from '@app/store/modal/actions';
import { getFileFromURL } from '@app/store/transport-layer/files';

export function* fetchPDF({ payload }: ReturnType<typeof contractLinkCreateLoadPdfRequest>) {
  try {
    const { data: pdfArrayBuffer } = yield call(getFileFromURL, payload.url);
    const { fileId, title, url } = payload;
    yield put(contractLinkCreateLoadPdfSuccess({ fileId, pdfArrayBuffer, title, url }));
  } catch (error) {
    yield put(contractLinkCreateLoadPdfFailure({ error }));
    yield put(
      modalOpen('CONFIRM', {
        title: '링크서명 만들기 실패',
        content: GLOBAL_ERROR_MESSAGE[error.message] || error.message,
      })
    );
  }
}

export default function* sagas() {
  yield all([takeLeading(contractLinkCreateLoadPdfRequest.type, fetchPDF)]);
}
